import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
})
export class AlertModalComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  @Input() instance: NgbModalRef;

  @Input() header: string;
  @Input() message: string;
  @Input() type: 'info' | 'question' = 'info';
  @Input() primaryButtonText = 'Ok';
  @Input() secondaryButtonText: string;
  @Input() btnClass: string;
  @Input() disablePrimaryBtn: boolean;

  @Input() primaryHandler = () => {};
  @Input() secondaryHandler = () => {};

  constructor() {}

  public handleInfoButton() {
    this.instance.close(true);
  }

  public handleButton(type: 'primary' | 'secondary') {
    if (type === 'primary') {
      this.instance.close(true);
    } else {
      this.instance.close(false);
    }
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.instance.dismissed.subscribe((reason) => {
        if (reason === 0) {
          if (this.type === 'info') {
            this.primaryHandler();
          } else {
            this.secondaryHandler();
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
